import AppService from "../services/AppService";
import AppManager from "../managers/AppManager";
import PermissionManager from "../managers/PermissionManager";
import SiteService from "../services/SiteService";
import UserService from "../services/UserService";

export default class AppUtil {

    initViewLayout(view) {
        if(view.layout === undefined) {
            view.layout = {}
        }

        if(view.layout.description === undefined) {
            view.layout.description = ''
        }

        if (view.view_type === 'gallery' && !view.layout.gallery) {
            view.layout.gallery = {
                mobile: {
                    columnCount: 2
                },
                desktop: {
                    columnCount: 3
                }
            }
        }
    }

    loadApp(appId) {
        let service = new AppService()

        service.initApp(appId).then((app) => {
            // this.initAppProperties(response)
            // let temp = new PermissionManager(app)
            // app.user_app_uuid = temp.appPermission()
            // app.user_data_uuid = temp.dataPermission()
            // webase.model.currentCollaboratorId = temp.currentCollaborator().id
            // webase.model.app = app
            // webase.managers.app = new AppManager(webase.model.app)
            // webase.managers.permission = new PermissionManager(webase.model.app)

            // console.log('***** app loaded *****')

        }).catch((message) => {
            console.log('error loading app')
            console.log(message)
        })
    }

    initAppProperties(app) {
        console.log('***** app loaded, initializing properties *****')
        let temp = new PermissionManager(app)
        app.user_app_uuid = temp.appPermission()
        app.user_data_uuid = temp.dataPermission()
        webase.model.currentCollaboratorId = temp.currentCollaborator().id
        webase.model.app = app
        webase.managers.app = new AppManager(webase.model.app)
        webase.managers.permission = new PermissionManager(webase.model.app)
        console.log(webase.model.currentCollaboratorId)
        console.log(webase.model.app.id)

        if(app.website_id) {
            let siteService = new SiteService()

            siteService.get(app.website_id).then((website) => {
                webase.model.website = website
            })
        }

        if (webase.managers.permission.isOwnerOrAdmin()) {
            let service = new UserService()
            service.permissions(app.id)
        }
    }

    getBasePageUrl() {
        if (process.env.NODE_ENV === 'development' || window.location.href.indexOf('localhost') > -1) {
            return 'http://localhost:3000/'
        }

        if (window.location.hostname.indexOf('webase.com') > -1) {
            return 'https://www.webase.com/' // make URLs relative
        }

        // if on a custom domain it can load from root
        return '/'
    }

    getBaseUrl() {
        if (process.env.NODE_ENV === 'development' || window.location.href.indexOf('localhost') > -1) {
            return 'http://localhost:3000'
        }

        if (window.location.hostname.indexOf('webase.com') > -1) {
            return '' // make URLs relative
        }

        return 'https://api.webase.com'
    }

    getHostUrl() {
        if (process.env.NODE_ENV === 'development' || window.location.href.indexOf('localhost') > -1) {
            return 'http://localhost:3000'
        }

        if (window.location.hostname.indexOf('webase.com') > -1) {
            return 'https://www.webase.com'
        }

        return 'https://api.webase.com'
    }

    getStripeKey() {
        if (process.env.NODE_ENV === "development") {
            return "pk_test_10MeTwHoWAYNa4KLJgrnK5cV00lSQrRJWz";
        }

        return "pk_live_ktkM6jzzhuJSsUvxxR5gyX1T00HAq7YJwu";
    }

    waitUntil(checkFn, checkDelay, timeout) {
        const startTime = Date.now()

        function check(resolve, reject) {
            if (checkFn()) {
                resolve()
            } else if (Date.now() - startTime > timeout) {
                reject()
            } else {
                setTimeout(() => check(resolve, reject), checkDelay)
            }
        }

        return new Promise((resolve, reject) => {
            check(resolve, reject)
        })
    }

}